// lcs 实现文本对比
const diff = function (s1, s2) {
  let m = s1.length, n = s2.length
  const dp = new Array(m + 1).fill(0).map(() => new Array(n + 1).fill(0));
  for (let i = 1; i <= m; i++) {
    const c1 = s1[i - 1];
    for (let j = 1; j <= n; j++) {
      const c2 = s2[j - 1];
      if (c1 === c2) {
        dp[i][j] = dp[i - 1][j - 1] + 1;
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
      }
    }
  }
  let i = m, j = n, res = []
  let t1 = new Array(m).fill(0), t2 = new Array(n).fill(0)
  while (i > 0 && j > 0) {
    let x = dp[i][j]
    let a = dp[i-1][j-1], b = dp[i-1][j], c = dp[i][j-1]
    if (x === b) {
      i--
      continue
    }
    if (x === c) {
      j--
      continue
    }
    if (x === a + 1) {
      j--
      i--
    }
    t1[i] = 1
    t2[j] = 1
  }
  res[0] = t1
  res[1] = t2
  return res
}
export {diff}